import React, { Component } from 'react';

import { connect } from 'react-redux';

import Footer from 'wanderu-component-footer';
import NotFound from 'wanderu-component-not-found';
import { BusLoader } from 'wanderu-components';
import {
    fetchCarrierContactAction,
    carrierContactSelectors,
} from 'wanderu-ducks-seo';
import {
    i18nCoordinator,
    selectLocale,
} from 'wanderu-i18n';

import carrierContactConfig from '../../../config/carriercontact.locale';
import CarrierContactComponent from '../../components/CarrierContact/CarrierContact';
import CarrierContactMeta from '../../components/CarrierContact/CarrierContactMeta/CarrierContactMeta';

class CarrierContactContainer extends Component {
    static async serverFetchData(opts) {
        const {
            dispatch,
            i18nCoordinator,
            getState,
            params,
        } = opts;
        const {
            locale,
        } = params;

        await dispatch(fetchCarrierContactAction.fetchCarrierContact(locale));

        await i18nCoordinator.registerTranslatableApp({
            ...carrierContactConfig,
            translationFetchFn: () => {
                return carrierContactSelectors.selectContent(getState(), locale);
            },
        });
    }

    async componentDidMount() {
        const {
            notFound,
            locale,
            content,
            isLoaded,
            fetchCarrierContact,
        } = this.props;

        if (notFound) {
            return;
        }

        if (!isLoaded) {
            fetchCarrierContact(locale);
        }

        if (content) {
            i18nCoordinator.updateTranslations(locale, content, carrierContactConfig.namespace);
            this.forceUpdate();
        }

        await i18nCoordinator.registerTranslatableApp({
            ...carrierContactConfig,
            translationFetchFn: () => {},
        });
    }

    async componentDidUpdate(prevProps) {
        const {
            locale,
            content,
            isFetching,
            fetchCarrierContact,
        } = this.props;
        const {
            locale: previousLocale,
            isFetching: previousIsFetching,
        } = prevProps;

        if (locale !== previousLocale) {
            fetchCarrierContact(locale);
        }

        if (previousIsFetching && !isFetching) {
            i18nCoordinator.updateTranslations(locale, content, carrierContactConfig.namespace);
            this.forceUpdate(); // the translations changed, but there's nothing that will cause a re-render, so we force it.
        }
    }

    componentWillUnmount() {
        i18nCoordinator.unregisterTranslatableApp(carrierContactConfig.namespace);
    }

    render() {
        const {
            content,
            error,
            isFetching,
            staticContext,
        } = this.props;

        if (staticContext) {
            staticContext.cache = {
                secondsFromNow: 60 * 60 * 24 * 7,
            };

            if (staticContext.url) {
                return null;
            } if (error) {
                staticContext.status = error.status;
                staticContext.cache = undefined;
            }
        }

        if (error) {
            return <NotFound status={error.status} />;
        }

        if (isFetching || !content) {
            return (
                <BusLoader large />
            );
        }

        return (
            <>
                <CarrierContactMeta />
                <CarrierContactComponent
                    {...this.props}
                />
                <Footer
                    limitLinkFlow
                />
            </>
        );
    }
}

function mapStateToProps(appState) {
    const locale = selectLocale(appState);
    const content = carrierContactSelectors.selectContent(appState, locale);

    return {
        content,
        locale,
        error: fetchCarrierContactAction.selectError(appState, locale),
        isFetching: fetchCarrierContactAction.selectWorking(appState, locale),
        isLoaded: fetchCarrierContactAction.selectSuccess(appState, locale),
        regionalData: carrierContactSelectors.selectRegionalData(appState, locale),
        regionNames: carrierContactSelectors.selectCarrierContactRegions(appState, locale),
        longFormContent: carrierContactSelectors.selectLongFormContent(appState, locale),
    };
}

const mapDispatchToProps = {
    fetchCarrierContact: fetchCarrierContactAction.fetchCarrierContact,
};

export {
    CarrierContactContainer,
    mapStateToProps,
};
export default connect(mapStateToProps, mapDispatchToProps)(CarrierContactContainer);
